export default __webpack_public_path__ + "static/SV-draugystes-467f5f34e54b623014220e75eb67962c.png";